<template>
    <div class="industries">
        <div v-for="(industry, key) in industries" :key="key" class="industry">
          <h2>{{ industry }}</h2>
          <div v-for="(client, key) in clients" :key="key" class="clients">
              <div v-if="client.industry === industry && client.name !== 'WISDOM'" class="client" :class="{ 'has-case-study': client.count != 0, }" v-html="client.name" @click="updateClient(client)"></div>
          </div>
        </div>
    </div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'Clients',
  data() {
    return {
      clients: [],
      industriesOrder: [
        "Tourism",
        "Legal",
        "Community Services (NFP)",
        "Hospitality",
        "Insurance",
        "Manufacturing",
        "Government",
        "Food & Beverage",
        "Automotive & Transport",
        "Health",
        "Retail",
        "Technology",
        "Sports",
        "Financial Services",
        "Professional Services",
        "Property",
        "Industrial",
        "Education",
        "Events",
        "Arts"
      ]
    }
  },
  methods: {
    updateClient(client) {
      if(client.count > 0) {
        window.dispatchEvent(new CustomEvent('wisdom-posts-client-localstorage-changed', {
          detail: {
            client
          }
        }));
      }
    },
  },
  mounted() {
    axios.get(`${window.location.origin}/wp-json/wp/v2/clients?per_page=2000`)
    .then(response => {
      this.clients = response.data
    })
  },
  computed: {
    industries() {
      let industriesArray = [];
      let sortedIndustriesArray = [];
      this.clients.forEach(client => {
        if(!industriesArray.includes(client.industry) && client.industry !== "") {
          industriesArray.push(client.industry)
        }
      })
      industriesArray.forEach((x) => {
        let foundIndex = this.industriesOrder.indexOf(x)
        sortedIndustriesArray[foundIndex] = x
      });

      return sortedIndustriesArray;


    }
  }
}
</script>
<style lang="scss">
    .client {
      color: #999;
    }
    .client.has-case-study {
        font-weight: bold;
        cursor: pointer;
        color: white;
    }
    .industries {
      padding: 0 2em;

      @media screen and (min-width: 640px) {
        columns: 3;
        margin-left: 10vw;
        margin-top: 40px;
      }
    }
    .industry {
      display: inline-block;
      width: 100%;
      margin-bottom: 1.5em;

      h2 {
        font-family: inherit;
        font-weight: bold;
        margin-bottom: 0.25em;
      }
    }
</style>